<template>
  <div class="xinwen">
     
    <div class="article_item" v-for="(item,index) in article" :key='index'>

      <div class="article_detaile" @click="getarticle_detaile(index)">
        <div class="article_title">
          {{item.title}}
        </div>
      
       <div>
             {{item.approvalDate.substr(0,10) }}
       </div>
 
      </div>
      <hr>

    </div>
    
    <div class="more">
       <router-link to='/allnews'></router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: "allnews",
  data() {
    return {
      article: []
    };
  },

  methods: {
    getartticle() {
      this.axios
        .get("http://www.yzparking.cn/system/announcement/findAll?page=0&size=5")
        .then(res => {
            this.article = res.data ;
          console.log(res.data.length);
          if (res.data != null || res.data.length != 0) {
           this.article.forEach(cur=>{
              cur.image=(cur.image+'?');
           })
           console.log(this.article)
            //
          }
        })
        .catch(err => {});
    },
    getarticle_detaile(index) {
      localStorage.setItem("detaile", this.article[index].document);
      this.$router.push({
        path: "/articledetaile",
        query: {
          title: this.article[index].title
        }
      });
    }
  },

  mounted() {
    this.getartticle();
  }
};
</script>

<style scoped>
.more{
    float:right;
    margin-top: 20px;
}
.xinwen{
    margin-bottom: 30px;width:1000px;margin:0px auto 80px auto;
}
.article_detaile {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  flex: 1 2;
  align-items: center;
  font-family: "宋体    ";
  min-height: 1.4rem;
  font-size: 16px;
  border-bottom:1px dashed  #d4c7c7;
  color:#013d7b;
}
.article_detaile img {
 width: 120px;
 height: 80px;
}
.article_title {
  line-height: 20px;
  font-weight: 600;
   border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/allnews.vue